import axios from "axios";
import UNIVERSAL from "config";
import { CREDENTIALS } from "utils/dataKeys";
import { loadFromLocalStorage } from "utils/manageLocalStorage";

const Axios = axios.create({
  baseURL: UNIVERSAL.BASEURL,
});

Axios.interceptors.request.use((config) => {
  config = {
    ...config,
    headers: {
      Authorization: `Bearer ${loadFromLocalStorage(CREDENTIALS)?.token}`,
    },
    metadata: { startTime: new Date() },
  };

  return config;
});

Axios.interceptors.response.use(
  (response) => {
    response.config.metadata.endTime = new Date();
    response.duration =
      response.config.metadata.endTime - response.config.metadata.startTime;
    return response;
  },
  async (error) => {
    if (error?.config) {
      error.config.metadata.endTime = new Date();
      error.duration =
        error.config.metadata.endTime - error.config.metadata.startTime;

      // If local API fails and we have a fallback, try it once
      const isLocal = error.config.baseURL?.includes("127.0.0.1");
      const isNetworkError =
        error.code === "ERR_NETWORK" ||
        error.message === "Network Error" ||
        error.code === "ERR_CONNECTION_REFUSED";

      if (isNetworkError && isLocal && !error.config.__retry && UNIVERSAL.FALLBACK_BASEURL) {
        const retryConfig = {
          ...error.config,
          __retry: true,
          baseURL: UNIVERSAL.FALLBACK_BASEURL,
        };
        try {
          const retryResp = await axios(retryConfig);
          return retryResp;
        } catch (retryErr) {
          return Promise.reject(retryErr);
        }
      }
    }
    return Promise.reject(error);
  },
);

export default Axios;
